import Head from 'next/head'
import { useRouter } from 'next/router'
import { SITE_CONFIG, getPageSeo } from '../../lib/seo-config'

const SEO = ({ slug, overrides } = {}) => {
  const router = useRouter()
  const resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, '')
  const resolved = getPageSeo(resolvedSlug)
  const seo = overrides ? { ...resolved, ...overrides } : resolved

  return (
    <Head>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.ogTitle} key="title" />
      {seo.noindex && <meta name="robots" content="noindex,follow" />}
      {!seo.noindex && (
        <>
          <link rel="canonical" href={seo.url} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={SITE_CONFIG.name} />
          <meta property="og:url" content={seo.url} />
          <meta property="og:description" content={seo.ogDescription} />
          <meta property="og:image" content={seo.ogImage} />
          <meta name="twitter:card" content={SITE_CONFIG.twitterCard} />
          <meta name="twitter:title" content={seo.twitterTitle} />
          <meta name="twitter:description" content={seo.twitterDescription} />
          <meta name="twitter:image" content={seo.twitterImage} />
        </>
      )}
    </Head>
  )
}

export default SEO
